module.exports = __webpack_public_path__ + "img/mapLogo.83884e76.png";